import { TextArea } from "../FormElements";
import { ReplaceWithDataSource } from "../helpers/variable";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<TextArea
			label="Message text (Large text)"
			value={cue.body}
			onChange={(value) => {
				onUpdate({
					body: value,
				});
			}}
		/>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
        `}
		>
			<span className="font-semibold">
				{<ReplaceWithDataSource text={cue.body} keepBrakets={true} styled={true} /> ||
					"Message"}
			</span>
		</div>
	);
};
